import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

export default function ModelCountry({
  formData,
  setFormData,
  setModalcountry,
}) {
  const [category, setCategory] = useState("");
  const [selectCatgory, setselectCatgory] = useState(formData?.country_index);
  const [tempCatgory, settempCatgory] = useState(formData?.country_index);

  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  useEffect(() => {
    setCategory(countrylist);
  }, [countrylist]);

  const handleValues = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      country_index: tempCatgory,
      country_id: tempCatgory.value,
    }));
    setselectCatgory(tempCatgory);
  };

  return (
    <>
      <button
        onClick={() => setModalcountry((state) => !state)}
        className ="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Select Country</h4>
        <div className ="form-group">
          <label>Select Country</label>
          <ReactSelect
            options={
              Array.isArray(category) &&
              category.map((lang) => ({ value: lang.id, label: lang.title }))
            }
            placeholder={"Select"}
            value={tempCatgory}
            onChange={(options) => {
              if (options) {
                settempCatgory(options);
              }
            }}
          />
        </div>
      </ModalBody>
      {/* <ModalFooter>
                <Button color="primary" onClick={() => { handleValues(); setModalcountry(state => !state) }}>
                    SAVE
                </Button>
            </ModalFooter>  */}
      <div className ="modal-footer ">
        <button
          className ="btn"
          onClick={() => {
            handleValues();
            setModalcountry((state) => !state);
          }}
        >
          Save
        </button>
      </div>
    </>
  );
}
